import React from 'react';

export const SectionContext = React.createContext<{ variant?: string }>({
	variant: 'default',
});
const SectionContextProvider = ({
	variant,
	children,
}: {
	variant: string;
	children: React.ReactNode;
}) => {
	const defaultContext = {
		variant,
	};

	return (
		<SectionContext.Provider value={defaultContext}>
			{children}
		</SectionContext.Provider>
	);
};

export default SectionContextProvider;
